/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CategoryMap } from './CategoryMap';
import {
    CategoryMapFromJSON,
    CategoryMapFromJSONTyped,
    CategoryMapToJSON,
} from './CategoryMap';

/**
 * 
 * @export
 * @interface ListValueCountsByCategoryResponseContent
 */
export interface ListValueCountsByCategoryResponseContent {
    /**
     * 
     * @type {CategoryMap}
     * @memberof ListValueCountsByCategoryResponseContent
     */
    analytics: CategoryMap;
}


/**
 * Check if a given object implements the ListValueCountsByCategoryResponseContent interface.
 */
export function instanceOfListValueCountsByCategoryResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "analytics" in value;

    return isInstance;
}

export function ListValueCountsByCategoryResponseContentFromJSON(json: any): ListValueCountsByCategoryResponseContent {
    return ListValueCountsByCategoryResponseContentFromJSONTyped(json, false);
}

export function ListValueCountsByCategoryResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListValueCountsByCategoryResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'analytics': CategoryMapFromJSON(json['analytics']),
    };
}

export function ListValueCountsByCategoryResponseContentToJSON(value?: ListValueCountsByCategoryResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'analytics': CategoryMapToJSON(value.analytics),
    };
}

